import type { ExternalSystemState } from './external-system-state.enum';
import type { PagedRequestDto } from '../pagination/models';

export interface ExternalSystemDto {
  id: number;
  name?: string;
  code?: string;
  state?: ExternalSystemState;
  inputQueueName?: string;
  outputQueueName?: string;
}

export interface ExternalSystemInputDto {
  id: number;
  name?: string;
  code?: string;
  state?: ExternalSystemState;
  inputQueueName?: string;
  outputQueueName?: string;
}

export interface ExternalSystemPagedRequestDto extends PagedRequestDto {
  name?: string;
  code?: string;
  state?: ExternalSystemState;
}

export interface ExternalSystemQueueInformationDto {
  id: number;
  inputQueueName: string;
  outputQueueName: string;
  externalSystemCode: string;
}
